import { IScript } from '../../models/IScript';

//@ts-ignore
const scriptHashWorker: Worker = new Worker(new URL('../../workers/scripts-hash', import.meta.url));;

if (!scriptHashWorker) {
    throw new Error('failed to create worker');
}

export function getScriptsHash(scripts: IScript[]) {
    return new Promise((resolve) => {
        const scriptHashWorkerMessageListener = (e) => {
            scriptHashWorker.removeEventListener('message', scriptHashWorkerMessageListener, false);
            resolve(e.data)
        };

        scriptHashWorker.addEventListener('message', scriptHashWorkerMessageListener, false);

        scriptHashWorker.postMessage({
            scripts: scripts,
        });

    })
}